// extracted by mini-css-extract-plugin
module.exports = {"card":"leftSidebarProfile_card__3htc8"};